<template>
  <div>
    <slot :data="{ dialogIsVisible }"></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { dialogManager } from './DialogManager.js'

export default defineComponent({
  name: 'DialogComponent',
  props: {
    onOpening: { type: Function, default: () => {} },
    onClosing: { type: Function, default: () => {} },
    onOpened: { type: Function, default: () => {} },
    onClosed: { type: Function, default: () => {} },
    onBackButtonClick: { type: Function, default: null },
  },
  data() {
    return {
      dialogIsVisible: false,
      stateId: '',
    }
  },
  mounted() {
    this.stateId = `dialog-${Date.now()}-${Math.random().toString(36).slice(2)}`
    dialogManager.register(this.stateId, this.hide)
  },
  beforeUnmount() {
    dialogManager.unregister(this.stateId)
  },
  methods: {
    isVisible() {
      return this.dialogIsVisible
    },
    show() {
      this.onOpening()
      this.dialogIsVisible = true
      dialogManager.open(this.stateId)
      this.onOpened()
    },
    hide(triggeredByBack = false, isForceClose = false) {
      if (!this.dialogIsVisible) return
      this.onClosing()
      this.dialogIsVisible = false
      this.onClosed()

      dialogManager.close(this.stateId, triggeredByBack, isForceClose)
      if (this.onBackButtonClick && triggeredByBack) this.onBackButtonClick()
    },
  },
})
</script>
